var _desc, _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Duotone/X",
    width: 16,
    height: 16,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.96 2.99L11.96 2.96C12.26 2.67 12.73 2.67 13.03 2.96C13.32 3.26 13.32 3.73 13.03 4.03L13 4.03L11.96 2.99ZM4.03 13L4.03 13.03C3.73 13.32 3.26 13.32 2.96 13.03C2.67 12.73 2.67 12.26 2.96 11.96L2.99 11.96L4.03 13Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 3.5L3.5 12.5",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 11.96L13.03 11.96C13.32 12.26 13.32 12.73 13.03 13.03C12.73 13.32 12.26 13.32 11.96 13.03L11.96 13L13 11.96ZM2.99 4.03L2.96 4.03C2.67 3.73 2.67 3.26 2.96 2.96C3.26 2.67 3.73 2.67 4.03 2.96L4.03 2.99L2.99 4.03Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 12.5L3.5 3.5",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.245d792dfa6fa4b5674c980a013582e1.svg";
export { ForwardRef as ReactComponent };